import { useMemo } from "react";
import { useInvoices } from "@/hooks/queries/useInvoices";
import {
  filterInvoices,
  getFilteredInvoiceTotals,
  getInvoiceMetrics,
  sortInvoicesByNewest,
} from "../invoice-calculations";
import type { InvoicePaymentFilter, InvoiceStatusFilter } from "../invoice.constants";

export function useInvoicesPageData(filters: {
  search: string;
  statusFilter: InvoiceStatusFilter;
  paymentFilter: InvoicePaymentFilter;
}) {
  const { data: invoices = [], isLoading } = useInvoices();

  const sortedInvoices = useMemo(() => sortInvoicesByNewest(invoices), [invoices]);
  const filteredInvoices = useMemo(
    () =>
      filterInvoices(
        sortedInvoices,
        filters.search,
        filters.statusFilter,
        filters.paymentFilter,
      ),
    [filters.paymentFilter, filters.search, filters.statusFilter, sortedInvoices],
  );
  const metrics = useMemo(() => getInvoiceMetrics(invoices), [invoices]);
  const filteredTotals = useMemo(() => getFilteredInvoiceTotals(filteredInvoices), [filteredInvoices]);

  return {
    invoices,
    sortedInvoices,
    filteredInvoices,
    filteredTotals,
    latest: sortedInvoices[0],
    metrics,
    isLoading,
  };
}
